import * as tslib_1 from "tslib";
import { AppActionTypes } from './types';
import { ProgressBarStepDetector } from '../../';
var initialState = {
    currentStep: null,
    location: null,
    translations: null,
    url: {
        query: null,
        productQuery: null,
        productOptions: null,
        context: null,
        hotel: null,
        hotelCode: null,
        productGroupId: undefined
    }
};
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case AppActionTypes.RECEIVE_TRANSLATIONS: {
            return tslib_1.__assign({}, state, { translations: action.translations });
        }
        case AppActionTypes.SET_LOCATION: {
            return tslib_1.__assign({}, state, { location: action.location });
        }
        case AppActionTypes.SET_URL_HOTEL_CODE: {
            return tslib_1.__assign({}, state, { url: tslib_1.__assign({}, state.url, { hotelCode: action.hotelCode }) });
        }
        case AppActionTypes.SET_URL_PRODUCT_GROUP_ID: {
            return tslib_1.__assign({}, state, { url: tslib_1.__assign({}, state.url, { productGroupId: action.productGroupId }) });
        }
        case AppActionTypes.SET_URL_QUERY: {
            return tslib_1.__assign({}, state, { url: tslib_1.__assign({}, state.url, { query: action.query }) });
        }
        case AppActionTypes.SET_URL_PRODUCT_QUERY: {
            return tslib_1.__assign({}, state, { url: tslib_1.__assign({}, state.url, { productQuery: action.productQuery }) });
        }
        case AppActionTypes.SET_URL_PRODUCT_OPTIONS: {
            return tslib_1.__assign({}, state, { url: tslib_1.__assign({}, state.url, { productOptions: action.productOptions }) });
        }
        case AppActionTypes.SET_URL_CONTEXT: {
            return tslib_1.__assign({}, state, { url: tslib_1.__assign({}, state.url, { context: action.context }) });
        }
        case AppActionTypes.SET_CURRENT_STEP: {
            var currentStep = ProgressBarStepDetector.detectProgressBarStep(action.location.href);
            return tslib_1.__assign({}, state, { currentStep: currentStep });
        }
        default: {
            return state;
        }
    }
};
export { reducer as appReducer };
